<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center )
        v-flex(xs12, sm12, md10, lg9, text-xs-center style="max-width: 1024px; margin: auto;")
          v-card(flat)
            breadcrumb(back='page6-14')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | HISTORIA 3 - ¿CÓMO PUEDE EL CRÉDITO HIPOTECARIO SER PARTE DE TU FUTURO?
            .video-responsive
              iframe.py-4(width="420" height="315" src="https://player.vimeo.com/video/287126281" frameborder="0" allowfullscreen)
            v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage('page6-16')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      show: false
    }
  },
  created: function () {
    window.setInterval(() => {
        this.show = true;
    },300);
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastChapter(page) {
      this.progress = true;
      eventBus.$emit('last_chapter', page);
    }
  },
};
</script>

<style lang="stylus">
.video-responsive
  overflow:hidden
  padding-bottom:56.25%
  position:relative
  height:0

.video-responsive iframe
  left:0
  top:0
  height:100%
  width:100%
  position:absolute

</style>
